export const titleForTrimFilter = [
	{ key: 'lameness', title: 'Хромота', id: 0 },
	{ key: 'groups', title: 'Группа', id: 1 },
	{ key: 'responsiblePersons', title: 'Исполнитель', id: 2 },
	{ key: 'lastTrim', title: 'Последняя обрезка', id: 3 },
]
